export default {
  placeholder: 'Please Select',
  title: 'Please Select Your Region',
  domesticTab: 'Domestic',
  overseasTab: 'Overseas',
  domesticInlandTab: 'Inland of China',
  zonesTab: 'Zones of China'
};